import { toast } from 'react-toastify';
import DocsCards from "components/blocks/Grids/DocsCards";
import useGetBlobs from "@/services/utils/useGetBlobs";

const FilesNoticesGrid = ({ documents }) => {
  
const {  handleDownloadBlob, isDownloading } = useGetBlobs();

const handleDownload = async (sasUri, nombreOriginal) => {
  try {
    await handleDownloadBlob(sasUri, nombreOriginal );
  } catch {
    toast.error('Error al descargar el archivo. Por favor, inténtalo de nuevo.');
  }
};
return(
  <DocsCards
    items={Array.isArray(documents) ? documents : []}
    getName={(d) => d.nombreOriginal ?? ""}
    onDownload={(d) => handleDownload(d.sasUri, d.nombreOriginal)}
    emptyMessage="No hay archivos adjuntos."
    onDownloading={(d) => isDownloading(d.sasUri)}
  />
);
};

export default FilesNoticesGrid;
